import * as React from 'react';
import { PolicyTitleModel, PolicyDetailModel } from '../models/PolicyModel';
import { PolicyService } from '../services/PolicyService';
import { Icon } from '@fluentui/react';
import { IDataResult, ResponseStatus } from '../../common/models/Result';
import { DataUtils } from '../../common/views/DataUtils';
import { Utils } from '../../common/views/Utils';

interface IGeneralPolicyProps { }

interface IGeneralPolicyState {
    titles: PolicyTitleModel[];
}

export default class GeneralPolicyView extends React.Component<IGeneralPolicyProps, IGeneralPolicyState> {
    constructor(props: IGeneralPolicyProps) {
        super(props);
        this.state = {
            titles: []
        };
    }

    public componentDidMount() {
        this.getList();
    }

    public render() {
        const { titles } = this.state;

        return <div className="p-10">
            {titles.map((title: PolicyTitleModel, index: number) => {
                return <div className="pv-10">
                    {this.printTitle(title.text)}

                    <div style={{ paddingLeft: 0 }}>
                        {title.details.map((detail: PolicyDetailModel, dIndex: number) => {
                            return <>{this.printDetail(detail.text)}</>;
                        })}
                    </div>
                </div>;
            })}
        </div>;
    }

    private printTitle = (text: string) => {
        return <h3>{text}</h3>;
    }

    private printDetail = (text: string) => {
        return <div className="ms-Grid-row pv-5">
            <div className={Utils.getColumnWidth(1)} style={{ maxWidth: 25 }}>
                <Icon iconName="CheckboxComposite" />
            </div>
            <div className={Utils.getColumnWidth(11)}>
                {text}
            </div>
        </div>;
    }

    private getList = () => {
        const service = new PolicyService();
        let request = service.getList();
        DataUtils.onRequest(request, this.onResult);
    }

    private onResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success) {
            this.setState({ titles: result.data });
        }
    }
}